import { useMemo } from 'react';
import { useMutation, MutationOptions } from 'react-query';
import ResidentService from '../../services/residentService';

// ENG-30200 AC#3/#4 -- the only mutation (of the three MiniProfileBridge
// uses) that can actually CREATE a household member; useResidentMutation/
// useApplicantMutation are both update-only (see buildSavePayload.js's
// top-of-file comment). Deliberately goes through the SAME existing
// endpoint the legacy EditResidentHousehold flow already uses (D4/
// CONTEXT.md) -- residentService.editResidentHousehold, PATCH
// .../residents/{residentId}/household -- NOT a new endpoint, sending a
// single-item array for the one new adult or minor (see buildSavePayload.js
// buildCreateAdultPayload/buildCreateMinorPayload for the exact shape).
const useCreateHouseholdMemberMutation = ({
  organizationId,
  propertyId,
  residentId,
  options,
}: {
  organizationId: string,
  propertyId: string,
  residentId: string,
  options: MutationOptions,
}) => {
  const residentService = useMemo(() => new ResidentService(), []);

  return useMutation(
    (payload) =>
      residentService.editResidentHousehold(
        residentId,
        payload,
        organizationId,
        propertyId,
      ),
    options,
  );
};

export default useCreateHouseholdMemberMutation;
